import CoreuiController from "../lib/coreui-controller"
import Collapse from "../coreui/collapse"

export default class CoreuiCollapseController extends CoreuiController {
  static Component = Collapse
}
